import React, { useState } from 'react';
import './view-quotation.css';
import { customerPayment, customerPaymentByCpg } from '../../api';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

// Simple placeholder payment step – integrate real payment logic later
const PaymentStep = ({ onBack, onPaid, isStepper, quotationNumber, amount, userId }) => {
  const { id: routeQuotationId } = useParams();
  const qNumber = quotationNumber || routeQuotationId || '';
  const [showDialog, setShowDialog] = useState(false);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [consentError, setConsentError] = useState(false);
  const lastConsentToastRef = React.useRef(0);
  console.log('PaymentStep props:', quotationNumber, userId);
  const openDialog = async () => {
    // Validate consent first
    if (!consentChecked) {
      setConsentError(true);
      const now = Date.now();
     
      // Attempt to focus the checkbox for accessibility (avoid optional chaining expression lint)
      try {
        const cb = document.getElementById('consent-checkbox');
        if (cb && typeof cb.focus === 'function') cb.focus();
      } catch(_) { /* swallow focus errors */ }
      return;
    }
    setShowDialog(true);
    setSubmitting(true);
    const amt = amount !== undefined && amount !== null ? amount : '0';
    const payload = {
      reqEmail: 'test@gmail.com', // blank email
      quotation_number: qNumber,
      amount: String(amt),
      // initateTime_pfbZDUvFueex: Date.now(),
      user_id: userId ,
    };
    try {
      const res = await customerPaymentByCpg(payload);
      const link = res?.data?.result?.URL || '';
      setPaymentLink(link);
      toast.success('Payment link generated');
      setShowResult(true);
      setSubmitting(false);
      if (onPaid) onPaid({ ...payload, paymentLink: link });
    } catch (err) {
      console.error('Failed to send payment link', err);
      toast.error(err?.response?.data?.error || 'Failed to send payment link');
      setSubmitting(false);
    }
  };
  React.useEffect(() => {
    if (consentChecked && consentError) setConsentError(false);
  }, [consentChecked, consentError]);

  const handleCopy = () => {
    if (!paymentLink) return;
    navigator.clipboard.writeText(paymentLink)
      .then(() => toast.success('Copied link'))
      .catch(() => toast.error('Copy failed'));
  };
  const resetAndClose = () => {
    if (submitting) return;
    setShowDialog(false);
    setShowResult(false);
    setPaymentLink("");
    setEmail("");
  };
  return (
    <div style={{ padding: 12 }}>
      <h3 style={{ margin: '0 0 16px', fontSize: 18, fontWeight: 600, color: '#00239c' }}>Payment</h3>
      <div style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 24 }}>
        Please review the quotation & customer details before proceeding. Quotation: <strong>{qNumber || '—'}</strong><br />
        Total Premium: <strong>{amount != null && !isNaN(Number(amount)) ? Number(amount).toFixed(2) : '—'}</strong>
     <br></br> <hr/>
         <label
           style={{
             display: 'flex',
             alignItems: 'flex-start',
             fontSize: 13,
             fontWeight: 500,
             marginBottom: consentError ? 4 : 12,
             padding: '8px 10px',
             borderRadius: 8,
             border: consentError ? '1px solid #d93025' : '1px solid #d3dbe5',
             background: consentError ? '#fff5f4' : '#f5f8fd',
             boxShadow: consentError ? '0 0 0 2px rgba(217,48,37,0.15)' : 'none',
             transition: 'all .18s'
           }}
         >
          <input
            id="consent-checkbox"
            type="checkbox"
            checked={consentChecked}
            onChange={e => setConsentChecked(e.target.checked)}
            style={{ marginRight: 8, marginTop: 2 }}
            aria-invalid={consentError ? 'true' : 'false'}
            aria-describedby={consentError ? 'consent-error-text' : undefined}
          />
          <span>
            I confirm that the information provided above is accurate and complete to the best of my knowledge.
          </span>
        </label>
        {consentError && (
          <div
            id="consent-error-text"
            style={{
              color: '#d93025',
              fontSize: 11.5,
              fontWeight: 500,
              marginBottom: 12,
              marginLeft: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }}
          >
            <span style={{ display:'inline-block', width:14, height:14, background:'#d93025', color:'#fff', borderRadius:3, fontSize:10, textAlign:'center', lineHeight:'14px', fontWeight:600 }}>!</span>
            Please provide your confirmation to continue.
          </div>
        )}
      </div>

      <div className="payment-step-actions">
       
        <div style={{ display: 'flex', gap: '12px' }}>
          {isStepper && (
            <button
              type="button"
              onClick={onBack}
              className="view-quotation-submit-button payment-back-button"
              style={{ background: '#6c7a89' }}
            >
              Back
            </button>
          )}
          <button
            type="button"
            onClick={openDialog}
            className="view-quotation-submit-button payment-pay-button"
            style={{
              background: consentChecked ? '#18a76d' : '#18a76d',
              opacity: consentChecked ? 1 : 0.78,
              position: 'relative'
            }}
          >
            Pay
          </button>
        </div>
      </div>
      {showDialog && (
        <div className="payment-modal-backdrop">
          <div className="payment-modal" role="dialog" aria-modal="true">
            <>
              <h4 style={{ margin: '0 0 10px', fontSize: 16, fontWeight: 600, color: '#122040' }}>Payment Link</h4>
              <div style={{ fontSize: 12, marginBottom: 14, color: '#415068', lineHeight:1.4 }}>
                A secure payment link has been generated. You can open it now or copy it to share.
              </div>
              <div style={{ background:'#f5f8fd', border:'1px solid #dbe4ef', borderRadius:10, padding:'12px 14px', fontSize:12, wordBreak:'break-all', position:'relative' }}>
                {paymentLink || (submitting ? 'Generating link...' : '—')}
                <div style={{ display:'flex', gap:8, marginTop:12, flexWrap:'wrap' }}>
                  <a
                    href={paymentLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="payment-modal-btn"
                    style={{ background:'#00239c', color:'#fff', textDecoration:'none', padding:'8px 18px', fontSize:12 }}
                  >Open Link</a>
                  <button
                    type="button"
                    onClick={handleCopy}
                    className="payment-modal-btn"
                    style={{ background:'#e4e9f3', color:'#2c3e55', padding:'8px 18px', fontSize:12 }}
                  >Copy Link</button>
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:20 }}>
                <button type="button" onClick={resetAndClose} className="payment-modal-btn payment-send-btn" style={{ background:'#18a76d' }}>Done</button>
              </div>
            </>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentStep;
